'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Star, Briefcase, Globe, ArrowRight } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide22Direction({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1707920664117-6ddd9adca8ef"
          alt="Hoàng hôn rực rỡ trên hồ Trị An, bóng người đứng nhìn ra mặt nước phản chiếu ánh vàng"
          className="w-full h-full object-cover opacity-15" />

        <div className="absolute inset-0 bg-gradient-to-br from-[#0f2318]/90 via-[#1a3a2a]/70 to-[#0f2318]/90" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[400px] rounded-full bg-[rgba(76,175,125,0.04)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Định hướng dài hạn</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Đây không phải
          </h2>
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] tracking-tight text-gradient-green">
            sự hợp tác một lần
          </h2>
        </div>

        <div className="fade-in-up mb-12">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 fade-in-up mb-8">
          {[
          {
            icon: <Star size={28} className="text-[#4caf7d]" />,
            title: 'Student Ambassador',
            desc: 'Sinh viên xuất sắc trở thành đại sứ — lan tỏa chương trình, kết nối bạn bè, và phát triển cùng Tri An Green Travel',
            step: '01',
            color: '#4caf7d'
          },
          {
            icon: <Briefcase size={28} className="text-[#e8a030]" />,
            title: 'Kết nối nghề nghiệp',
            desc: 'Sinh viên có cơ hội thực tập, cộng tác, và phát triển sự nghiệp trong lĩnh vực du lịch sinh thái và phát triển bền vững',
            step: '02',
            color: '#e8a030'
          },
          {
            icon: <Globe size={28} className="text-[#a8d87a]" />,
            title: 'Mở rộng chương trình',
            desc: 'Mỗi mùa một chủ đề mới, nhiều trường tham gia hơn, và hành trình xanh ngày càng lan rộng khắp Việt Nam',
            step: '03',
            color: '#a8d87a'
          }].
          map((item, i) =>
          <div
            key={`dir-${i}`}
            className="rounded-2xl p-7 relative overflow-hidden transition-all duration-300 hover:-translate-y-1"
            style={{
              background: `linear-gradient(145deg, ${item.color}10 0%, ${item.color}03 100%)`,
              border: `1px solid ${item.color}22`
            }}>

              <div
              className="absolute top-5 right-5 font-display font-900 text-[60px] leading-none opacity-[0.06]"
              style={{ color: item.color }}>

                {item.step}
              </div>
              <div
              className="p-3 rounded-xl inline-flex mb-5"
              style={{ background: `${item.color}18` }}>

                {item.icon}
              </div>
              <h3 className="font-display font-700 text-[18px] text-[#f0ede6] mb-3">{item.title}</h3>
              <p className="font-body text-[14px] text-[#a0b8a8] leading-relaxed">{item.desc}</p>
            </div>
          )}
        </div>

        <div className="fade-in-up amber-card p-6 lg:p-8 flex items-center gap-5">
          <ArrowRight size={24} className="text-[#e8a030] flex-shrink-0" />
          <p className="font-body text-[15px] text-[#a0b8a8] leading-relaxed">
            Mỗi đợt chương trình là{' '}
            <span className="text-[#f0ede6] font-600">một mùa hạt giống được gieo</span> —
            và chúng tôi cam kết chăm sóc để chúng{' '}
            <span className="text-[#e8a030] font-600">nảy mầm và lớn lên</span>
          </p>
        </div>
      </div>
    </SlideWrapper>);

}